export const TYPES = {
  SET_DEFAULT_SETTING_BAILIFF: "default_setting/SET_DEFAULT_SETTING_BAILIFF",
};
